import { TooltipTable } from './styled';
import { D3Node } from './types';
import { calcTooltipValue } from './utils/utils';
import { toCurrencyTruncated } from '@simplywallst/formatting';
import type { CurrencyISO } from '@/constants/currencies';

type Props = {
  node: D3Node;
  currencyISO: CurrencyISO;
};

const SankeyNodeTooltip = ({ node, currencyISO }: Props) => {
  const bodyInfo = calcTooltipValue(node);

  return (
    <TooltipTable>
      <thead>
        <tr>
          <th>{node.key}</th>
          <th>{toCurrencyTruncated(node.value, 2, currencyISO)}</th>
        </tr>
      </thead>
      <tbody>
        {bodyInfo.map((info) => (
          <tr key={info.label}>
            <td>{info.label}</td>
            <td>{info.value}</td>
          </tr>
        ))}
      </tbody>
    </TooltipTable>
  );
};

export default SankeyNodeTooltip;
